import React from "react"


export default function FormLabel({htmlFor, className, children}: {htmlFor?: string, className?: string, children?: any}) {
    return <label htmlFor={htmlFor} className={`${className} block text-zinc-600 dark:text-gray-500 text-xs mb-1`}>{children}</label>
}
